import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Row,
    Col,
    Button,
    Form,
    Card,
    Breadcrumb,
    ButtonToolbar,
    ButtonGroup,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { Input, SelectInput } from "../Components/Input";
import { getOptions } from "../Util/util";

import RequestStatus from "../Components/RequestStatus";
import { getAll as getAllCategories } from "../Store/Actions/Admin/Category";
import { getUserExams } from "../Store/Actions/Admin/Exams";
import ExamCard from "../Components/ExamsCard";

const PurchasedExams = (props) => {
    const [state, setState] = useState({
        queryStr: "",
        categoryId: "",
        currentPage: 1,
        pagination: true,
    });
    const [alertStatus, setAlertStatus] = useState(true);

    const examState = useSelector((state) => state.exams);
    const exams = examState.userExams;
    const totalPages = examState.userTotalPages;
    const categoryState = useSelector((state) => state.categories);

    let errors = [];
    if (typeof examState.errors !== "undefined") {
        examState.errors.map((item) => (errors[item.param] = item.msg));
    }

    const dispatch = useDispatch();

    const getExams = () => {
        dispatch(getUserExams(state));
    };

    useEffect(() => {
        dispatch(getAllCategories());
        getExams();
    }, [dispatch]);

    const onChangeHandler = (field, value) => {
        setState({ ...state, [field]: value });
    };

    const resetForm = (e) => {
        e.preventDefault();
        setState({
            queryStr: "",
            categoryId: "",
            currentPage: 1,
        });
    };

    const submitForm = (e) => {
        e.preventDefault();
        setAlertStatus(true);
        dispatch(getUserExams({ ...state }));
    };

    const getPaginationButtons = () => {
        if (totalPages === 1) {
            return <></>;
        }
        const buttons = [];
        for (let i = 1; i <= totalPages; i++) {
            buttons.push(<Button key={i}>{i}</Button>);
        }
        return buttons;
    };

    return (
        <>
            <Breadcrumb>
                <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                </li>
                <Breadcrumb.Item active>Purchase Exams</Breadcrumb.Item>
            </Breadcrumb>
            <Card>
                <Card.Body>
                    <Form onSubmit={submitForm}>
                        <Row>
                            <Col md={4}>
                                <Input
                                    type="text"
                                    name="name"
                                    label="Exam Name"
                                    placeholder="Search Exam By Name"
                                    value={state.queryStr}
                                    onChange={(e) =>
                                        onChangeHandler(
                                            "queryStr",
                                            e.target.value
                                        )
                                    }
                                />
                            </Col>
                            <Col md={4}>
                                <SelectInput
                                    errMessage={errors["categoryId"]}
                                    name="categoryId"
                                    placeholder="Category"
                                    label="Category"
                                    type="text"
                                    defaulttext="All"
                                    Options={getOptions(
                                        categoryState.categories,
                                        "name",
                                        "id"
                                    )}
                                    value={state.categoryId}
                                    handleChange={(e) =>
                                        onChangeHandler(
                                            "categoryId",
                                            e.target.value
                                        )
                                    }
                                    controlId="Category"
                                />
                            </Col>
                            <Col md="4" className="mt-2 text-middle">
                                <br />
                                <Button variant="primary" type="Submit">
                                    Search
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                    variant="secondary"
                                    onClick={resetForm}
                                    type="Button"
                                >
                                    Reset
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>
            <br />
            <ExamCard exams={exams} purchased={true} />

            <div fixed="bottom" className="mt-4 text-right">
                <ButtonToolbar
                    align="end"
                    aria-label="Pages"
                    className="justify-content-end"
                >
                    <ButtonGroup className="me-2" aria-label="First group">
                        {getPaginationButtons()}
                    </ButtonGroup>
                </ButtonToolbar>
            </div>

            <div className="text-center mt-6">
                <RequestStatus
                    stateObj={examState}
                    alertStatus={alertStatus}
                    setAlertStatus={setAlertStatus}
                />
            </div>
        </>
    );
};

export default PurchasedExams;
